import { round2, vals } from "@/lib/format";

const sum = (a, f) => round2(a.reduce((s, x) => s + (Number(f(x)) || 0), 0));
const NON_CASH = ["card", "credit", "split", "advance", "transfer"];

export function profitBetween(view, from, to) {
  const inR = (iso) => { const d = (iso || "").slice(0, 10); return d >= from && d <= to; };
  const cost = (i) => (i.cost ?? view.products[i.product_id]?.cost ?? 0) * i.qty;
  const sales = vals(view.sales).filter((s) => inR(s.created_at));
  const paid = sales.filter((s) => s.payment !== "house");
  const house = sales.filter((s) => s.payment === "house");
  const returns = vals(view.returns).filter((r) => inR(r.created_at));
  const expenses = vals(view.expenses).filter((e) => inR(e.created_at));
  const shifts = vals(view.shifts).filter((s) => s.status === "closed" && inR(s.closed_at));
  const waste = vals(view.waste || {}).filter((w) => !w.deleted && inR(w.created_at));
  const r = {
    waste: sum(waste, (w) => w.loss),
    from, to, count: paid.length,
    revenue: sum(paid, (s) => s.total), cash_revenue: sum(paid.filter((s) => !NON_CASH.includes(s.payment)), (s) => s.total),
    cogs: sum(paid, (s) => (s.items || []).reduce((a, i) => a + cost(i), 0)),
    returns: sum(returns, (x) => x.amount), house_cost: sum(house, (s) => (s.items || []).reduce((a, i) => a + cost(i), 0)),
    expenses: sum(expenses, (e) => e.amount), cash_diff: sum(shifts, (s) => (s.counted || 0) - (s.expected || 0)),
  };
  r.gross = round2(r.revenue - r.returns - r.cogs);
  r.net = round2(r.gross - r.house_cost - r.expenses - r.waste + r.cash_diff);
  r.margin = r.revenue ? Math.round((r.net / r.revenue) * 100) : 0;
  return r;
}

const iso = (d) => d.toISOString().slice(0, 10);
const addDays = (d, n) => { const x = new Date(d); x.setUTCDate(x.getUTCDate() + n); return x; };
export const startOfWeek = (d) => { const x = new Date(d); const dow = (x.getUTCDay() + 6) % 7; return addDays(x, -dow); };

export function profitSummary(view) {
  const today = new Date();
  const t = iso(today);
  const first = vals(view.sales).map((s) => (s.created_at || "").slice(0, 10)).filter(Boolean).sort()[0] || t;
  return {
    day: profitBetween(view, t, t),
    week: profitBetween(view, iso(startOfWeek(today)), t),
    month: profitBetween(view, t.slice(0, 7) + "-01", t),
    total: profitBetween(view, first, t),
  };
}

export function profitSeries(view, mode) {
  const today = new Date();
  const out = [];
  if (mode === "day") for (let i = 29; i >= 0; i--) { const d = iso(addDays(today, -i)); out.push({ label: d.slice(5), ...profitBetween(view, d, d) }); }
  if (mode === "week") for (let i = 11; i >= 0; i--) { const s = addDays(startOfWeek(today), -7 * i); const e = addDays(s, 6); out.push({ label: iso(s).slice(5), ...profitBetween(view, iso(s), iso(e)) }); }
  if (mode === "month") for (let i = 11; i >= 0; i--) { const d = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - i, 1)); const e = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)); out.push({ label: iso(d).slice(0, 7), ...profitBetween(view, iso(d), iso(e)) }); }
  return out;
}
